import { queryOptions, useQuery } from '@tanstack/react-query'

import { env } from '@/src/config/env'

import { getIsLoggedIn } from '../../auth/utils/getIsLoggedIn'
import { statusApi } from '../api/statusApi'

export const getStatusOptions = () =>
  queryOptions({
    queryKey: ['status'],
    queryFn: ({ signal }) => statusApi.getStatus({ signal }),
    retry: 1,
    refetchInterval: env.EXPO_PUBLIC_NOTIFICATIONS_POLLING_INTERVAL || 45 * 1000, // Fetch notifications every minute
    staleTime: 60 * 1000 * 3, // 3 minutes
    enabled: getIsLoggedIn(),
  })

export const useStatusQuery = () => useQuery(getStatusOptions())
